 
import styled, { css } from 'styled-components';
import { Col as BootstrapCol, Col, Row } from 'react-bootstrap';

import theme from 'v3/theme';

const routeCardLightGreen = '#d8f7f0';

export const ChecklistContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0;
  max-height: calc(55px * 3);
  overflow-y: auto;
`;

export const ChecklistItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

export const Marker = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${theme.colors.medium_gray};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 4px;
  left: -9px;

  ${({ progress, completed }) =>
    completed &&
    progress &&
    css`
      border-color: ${theme.colors.success};
      background-color: ${theme.colors.success};
    `}

  ${({ progress, completed }) =>
    progress &&
    !completed &&
    css`
      border-color: ${theme.colors.orange};
      background-color: ${theme.colors.orange};
    `}

  ${({ progress, completed }) =>
    !progress &&
    !completed &&
    css`
      border-color: ${theme.colors.medium_gray};
      background-color: ${theme.colors.medium_gray};
    `}
`;

Marker.Tray = styled.div`
  border-left: 2px dashed ${theme.colors.medium_gray};
  height: 100%;
  min-height: 100px;
  width: 0;
  margin: 0 auto;

  ${({ progress, completed }) =>
    completed &&
    progress &&
    css`
      border-color: ${theme.colors.success};
      background-color: ${theme.colors.white};
    `}

  ${({ progress, completed }) =>
    progress &&
    !completed &&
    css`
      border-color: ${theme.colors.orange};
      background-color: ${theme.colors.white};
    `}

  ${({ progress, completed }) =>
    !progress &&
    !completed &&
    css`
      border-color: ${theme.colors.medium_gray};
      background-color: ${theme.colors.white};
    `}
`;

export const Schedules = styled(BootstrapCol)`
  position: relative;
  display: flex;
  align-items: stretch;
  align-self: stretch;
  padding: 12px 16px;
  border-radius: 0 5px 5px 0;
  border: 1px solid ${theme.colors.secondary};
  margin-bottom: 0;
  > * {
    width: 100%;
    height: 100%;
  }

  ${({ progress, completed }) =>
    completed &&
    progress &&
    css`
      border-color: ${routeCardLightGreen};
      background-color: ${routeCardLightGreen};
    `}

  ${({ progress, completed }) =>
    progress &&
    !completed &&
    css`
      border-color: ${theme.colors.yellow_indicator};
      background-color: ${theme.colors.yellow_indicator};
    `}

    ${({ progress, completed }) =>
    !progress &&
    !completed &&
    css`
      border-color: ${theme.colors.white};
      background-color: ${theme.colors.white};
    `}

  ${({ $showLeftDivider }) =>
    $showLeftDivider &&
    css`
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        border-left: 1px dashed ${theme.colors.medium_gray};
      }
    `}
`;

export const RouteLocationCol = styled(Col)`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  padding: 12px 16px;
  border-radius: 5px 0 0 5px;
  border: 1px solid ${theme.colors.secondary};
  margin-bottom: 0;
  > * {
    width: 100%;
  }

  ${({ progress, completed }) =>
    completed &&
    progress &&
    css`
      border-color: ${routeCardLightGreen};
      background-color: ${routeCardLightGreen};
    `}

  ${({ progress, completed }) =>
    progress &&
    !completed &&
    css`
      border-color: ${theme.colors.yellow_indicator};
      background-color: ${theme.colors.yellow_indicator};
    `}

  ${({ progress, completed }) =>
    !progress &&
    !completed &&
    css`
      border-color: ${theme.colors.white};
      background-color: ${theme.colors.white};
    `}
`;

export const RouteColumnsGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ $hasStartSchedule }) =>
    $hasStartSchedule ? '3fr 2fr 1fr 2fr' : '2fr 2fr 1fr 2fr'};
  align-items: stretch;
  width: 100%;
  height: 100%;
`;

export const RouteGridCell = styled.div`
  height: 100%;
  padding: 0 0.75rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RouteGridBodyCell = styled(RouteGridCell)`
  position: relative;
  align-self: stretch;

  ${({ $showDivider }) =>
    $showDivider &&
    css`
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        border-left: 1px dashed ${theme.colors.medium_gray};
      }
    `}
`;

export const TrackingContainer = styled(Row)`
  padding: 0;
`;

export const StyledTrackingCol = styled(Col)`
  padding: 0;
  display: flex;
  align-items: flex-start;
  overflow-x: auto;
  justify-content: center;
  img:first-child {
    width: 4rem;
    height: 4rem;
  }
  img:last-child {
    width: 4rem;
  }
  @media (max-width: 1200px) {
    justify-content: start;
  }
`;

export const StyledTrackTitle = styled.div`
  display: flex;
  padding-top: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  min-width: 128px;
  & > div {
    display: flex;
  }
`;

export const StyledTrackContent = styled.div`
  display: flex;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 0.25rem;
  & > div {
    display: flex;
  }
`;

export const StyledTrackFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  min-width: 128px;
  & > div {
    display: flex;
    text-align: center;
  }
`;

export const OccurrenceMainDetailsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const SectionTitle = styled.div`
  width: 100%;
  padding-bottom: 6px;
  margin-bottom: 8px;
  border-bottom: 1px solid ${theme.colors.medium_gray};
`;

export const LocationContent = styled.div`
  position: relative;
  padding-left: 28px;
`;

export const FeedbacksContainer = styled.div`
  margin-top: 1rem;
  padding: 1rem 1.25rem;
  max-height: 32rem;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  :not(:hover)::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
  }
  :not(:hover)::-webkit-scrollbar-track {
    opacity: 0;
  }
  :not(:hover)::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
  }
  :hover::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
  }
  :hover::-webkit-scrollbar-track {
    background: ${theme.colors.light_gray};
    opacity: 0.5;
  }
  :hover::-webkit-scrollbar-thumb {
    background: #e1e1e1;
    border-radius: 10px;
  }
`;

export const FeedbackItemContainer = styled.div`
  padding: 1rem 0 0 0;
  position: relative;
`;

export const FeedbackMarker = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: ${theme.colors.medium_gray};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;

  ${({ $isLast }) =>
    $isLast &&
    css`
      margin-top: -6px;
      margin-bottom: 20px;
    `};
`;

export const FeedbackTray = styled.div`
  margin-top: 1rem !important;
  border-left: 2px dashed ${theme.colors.medium_gray};
  height: 90%;
  width: 100%;
  margin-left: 7px;
`;
